// src/components/strumenti/LeasingVsAcquisto.js
import React, { useState } from "react";
import { RefreshCw, Printer } from "lucide-react";
import { leggiNumero } from "../../utils/numeriStrumenti";

const inp = { padding:"10px 12px", border:"1px solid #e5e7eb", borderRadius:8, fontSize:14, fontFamily:"'Inter',sans-serif", outline:"none", width:"100%" };
const lbl = { fontSize:11, fontWeight:600, color:"#6b7280", display:"block", marginBottom:4 };

export default function LeasingVsAcquisto() {
  const [denominazione, setDenominazione] = useState("");
  const [note, setNote] = useState("");
  const [canoneMensile, setCanoneMensile] = useState("");
  const [numeroRate, setNumeroRate] = useState("48");
  const [maxirataIniziale, setMaxirataIniziale] = useState("");
  const [valoreRiscatto, setValoreRiscatto] = useState("");
  const [prezzoAcquisto, setPrezzoAcquisto] = useState("");

  const canone = leggiNumero(canoneMensile)||0;
  const n = parseInt(numeroRate)||0;
  const maxirata = leggiNumero(maxirataIniziale)||0;
  const riscatto = leggiNumero(valoreRiscatto)||0;
  const prezzo = leggiNumero(prezzoAcquisto)||0;

  const costoTotaleLeasing = maxirata + (canone*n) + riscatto;
  const puoConfrontare = costoTotaleLeasing>0 && prezzo>0;
  const differenza = puoConfrontare ? costoTotaleLeasing-prezzo : null;
  const convieneAcquisto = differenza!==null && differenza>0;

  const stampaPDF = () => {
    const win = window.open("", "_blank");
    const oggi = new Date().toLocaleDateString("it-IT", { day:"numeric", month:"long", year:"numeric" });
    win.document.write(`<!DOCTYPE html><html><head><meta charset="utf-8"/>
    <title>Leasing vs Acquisto — ${denominazione}</title>
    <style>
      *{margin:0;padding:0;box-sizing:border-box;}
      body{font-family:Arial,sans-serif;color:#111;padding:14mm;font-size:12px;}
      @media screen{body{max-width:800px;margin:0 auto;background:#fff;box-shadow:0 2px 16px rgba(0,0,0,.08);}}
      @page{size:A4;margin:14mm;}
      h1{font-size:18px;color:#059669;margin-bottom:2px;}
      .sub{font-size:11px;color:#6b7280;margin-bottom:16px;}
      table{width:100%;border-collapse:collapse;margin-bottom:14px;}
      td,th{border:1px solid #e5e7eb;padding:6px 10px;text-align:left;font-size:12px;}
      th{background:#f9fafb;width:45%;color:#374151;}
      .risultato{background:#ecfdf5;border:1px solid #a7f3d0;border-radius:8px;padding:16px;text-align:center;margin-bottom:14px;}
      .risultato .val{font-size:22px;font-weight:800;color:#059669;}
      .avviso{background:#fffbeb;border:1px solid #fde68a;border-radius:8px;padding:10px 12px;font-size:10.5px;color:#92400e;}
    </style></head><body>
      <h1>⚖️ Leasing vs Acquisto</h1>
      <div class="sub">Nexiora — Strumenti Tecnici · Generato il ${oggi}</div>
      <table>
        <tr><th>Denominazione</th><td>${denominazione || "—"}</td></tr>
        <tr><th>Note</th><td>${note || "—"}</td></tr>
      </table>
      <table>
        <tr><th>Canone mensile leasing</th><td>${canoneMensile || "—"} €</td></tr>
        <tr><th>N° rate</th><td>${numeroRate}</td></tr>
        <tr><th>Maxirata iniziale</th><td>${maxirataIniziale || "0"} €</td></tr>
        <tr><th>Valore di riscatto</th><td>${valoreRiscatto || "0"} €</td></tr>
        <tr><th>Prezzo acquisto diretto</th><td>${prezzoAcquisto || "—"} €</td></tr>
      </table>
      <div class="risultato">
        <div style="display:flex;justify-content:space-around;margin-bottom:10px;">
          <div><div style="font-size:11px;color:#9ca3af;">Costo totale leasing</div><div style="font-weight:700;">${costoTotaleLeasing.toLocaleString("it-IT",{maximumFractionDigits:2})} €</div></div>
          <div><div style="font-size:11px;color:#9ca3af;">Costo acquisto</div><div style="font-weight:700;">${prezzo.toLocaleString("it-IT",{maximumFractionDigits:2})} €</div></div>
        </div>
        <div class="val">${convieneAcquisto ? "Conviene l'acquisto diretto" : "Conviene il leasing"}</div>
        <div style="font-size:12px;color:#6b7280;margin-top:4px;">Differenza: ${differenza!==null?Math.abs(differenza).toLocaleString("it-IT",{maximumFractionDigits:2}):"—"} €</div>
      </div>
      <div class="avviso">Confronto puramente nominale sui costi totali — non considera deducibilità fiscale, IVA, costo opportunità del capitale o altri benefici che possono cambiare la convenienza reale. Consultare il commercialista per la valutazione completa.</div>
      
    </body></html>`);
    win.document.close();
    setTimeout(()=>{
      if (win.closed) return;
      const style = win.document.createElement("style");
      style.textContent = "@media print { .no-print-btn { display:none !important; } }";
      win.document.head.appendChild(style);
      const btn = win.document.createElement("button");
      btn.textContent = "🖨️ Stampa";
      btn.className = "no-print-btn";
      btn.onclick = () => win.print();
      btn.style.cssText = "position:fixed;top:16px;right:16px;z-index:9999;padding:10px 20px;background:#7c3aed;color:#fff;border:none;border-radius:8px;font-size:14px;font-weight:700;cursor:pointer;font-family:Arial,sans-serif;box-shadow:0 4px 12px rgba(0,0,0,.2);";
      win.document.body.appendChild(btn);
    }, 50);
  };

  return (
    <div>
      <div style={{ background:"#f9fafb", border:"1px solid #e5e7eb", borderRadius:8, padding:12, marginBottom:16 }}>
        <div style={{ marginBottom:8 }}>
          <label style={lbl}>Denominazione (necessaria per la stampa)</label>
          <input value={denominazione} onChange={e=>setDenominazione(e.target.value)} style={inp} placeholder="Es. Escavatore Caterpillar 305"/>
        </div>
        <div>
          <label style={lbl}>Note (facoltativo)</label>
          <input value={note} onChange={e=>setNote(e.target.value)} style={inp} placeholder="Es. Preventivo concessionaria XY"/>
        </div>
      </div>

      <div style={{ fontSize:12, fontWeight:700, color:"#6b7280", marginBottom:8 }}>LEASING</div>
      <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:10, marginBottom:10 }}>
        <div>
          <label style={lbl}>Canone mensile (€)</label>
          <input value={canoneMensile} onChange={e=>setCanoneMensile(e.target.value)} style={inp} placeholder="Es. 450"/>
        </div>
        <div>
          <label style={lbl}>N° rate</label>
          <input value={numeroRate} onChange={e=>setNumeroRate(e.target.value)} style={inp}/>
        </div>
      </div>
      <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:10, marginBottom:16 }}>
        <div>
          <label style={lbl}>Maxirata iniziale (€, facolt.)</label>
          <input value={maxirataIniziale} onChange={e=>setMaxirataIniziale(e.target.value)} style={inp} placeholder="Es. 3000"/>
        </div>
        <div>
          <label style={lbl}>Valore di riscatto finale (€)</label>
          <input value={valoreRiscatto} onChange={e=>setValoreRiscatto(e.target.value)} style={inp} placeholder="Es. 1"/>
        </div>
      </div>

      <div style={{ fontSize:12, fontWeight:700, color:"#6b7280", marginBottom:8 }}>ACQUISTO DIRETTO</div>
      <div style={{ marginBottom:16 }}>
        <label style={lbl}>Prezzo di acquisto (€)</label>
        <input value={prezzoAcquisto} onChange={e=>setPrezzoAcquisto(e.target.value)} style={inp} placeholder="Es. 22000"/>
      </div>

      <div style={{ background:"#ecfdf5", border:"1px solid #a7f3d0", borderRadius:10, padding:"14px 16px" }}>
        <div style={{ display:"flex", justifyContent:"space-around", marginBottom: puoConfrontare?10:0 }}>
          <div style={{textAlign:"center"}}>
            <div style={{ fontSize:11, color:"#9ca3af", fontWeight:600 }}>Costo totale leasing</div>
            <div style={{ fontSize:16, fontWeight:700, color:"#374151" }}>{costoTotaleLeasing>0 ? costoTotaleLeasing.toLocaleString("it-IT",{maximumFractionDigits:2}) : "—"} €</div>
          </div>
          <div style={{textAlign:"center"}}>
            <div style={{ fontSize:11, color:"#9ca3af", fontWeight:600 }}>Costo acquisto</div>
            <div style={{ fontSize:16, fontWeight:700, color:"#374151" }}>{prezzo>0 ? prezzo.toLocaleString("it-IT",{maximumFractionDigits:2}) : "—"} €</div>
          </div>
        </div>
        {puoConfrontare && (
          <div style={{ textAlign:"center", borderTop:"1px solid #a7f3d0", paddingTop:10 }}>
            <div style={{ fontSize:16, fontWeight:800, color:"#059669" }}>
              {convieneAcquisto ? "Conviene l'acquisto diretto" : "Conviene il leasing"}
            </div>
            <div style={{ fontSize:12, color:"#6b7280", marginTop:2 }}>Differenza: {Math.abs(differenza).toLocaleString("it-IT",{maximumFractionDigits:2})} €</div>
          </div>
        )}
      </div>
      <div style={{ fontSize:10, color:"#9ca3af", marginTop:8, textAlign:"center" }}>
        Confronto puramente nominale sui costi totali — non considera deducibilità fiscale, IVA, costo opportunità del capitale o altri benefici che possono cambiare la convenienza reale. Consultare il commercialista per la valutazione completa.
      </div>

      <div style={{ display:"flex", alignItems:"center", justifyContent:"space-between", marginTop:12 }}>
        <button onClick={()=>{setCanoneMensile("");setNumeroRate("48");setMaxirataIniziale("");setValoreRiscatto("");setPrezzoAcquisto("");setDenominazione("");setNote("");}}
          style={{ display:"flex", alignItems:"center", gap:6, fontSize:12, color:"#9ca3af", background:"none", border:"none", cursor:"pointer" }}>
          <RefreshCw size={12}/> Azzera
        </button>
        <button onClick={stampaPDF} disabled={!denominazione.trim()}
          title={!denominazione.trim() ? "Inserisci la denominazione per stampare" : "Stampa PDF"}
          style={{ display:"flex", alignItems:"center", gap:6, fontSize:12, fontWeight:700,
            color: denominazione.trim() ? "#059669" : "#a7f3d0",
            background: denominazione.trim() ? "#ecfdf5" : "#f9fafb",
            border:`1px solid ${denominazione.trim() ? "#a7f3d0" : "#e5e7eb"}`,
            borderRadius:8, padding:"7px 14px", cursor: denominazione.trim() ? "pointer" : "not-allowed" }}>
          <Printer size={13}/> Stampa PDF
        </button>
      </div>
    </div>
  );
}
